module.exports = __webpack_public_path__ + "static/media/clock.b06d2169.svg";